export class GetEventsFilterRequest {
  StatusIds: number[] = [];
  LocationIds: number[] = [];
  FromDate?: string;
  ToDate?: string;
}
